import styled from 'styled-components';
import { Text } from 'components/Typography';

export const DescriptionMetadata = styled(Text).attrs(
  ({ weight = 'normal' }) => ({
    variant: 'button',
    weight,
  }),
)`
  font-size: 11px;
`;
